"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pinComment = exports.autocompleteMentions = exports.deleteComment = exports.sendComment = exports.getAllComments = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var query_string_1 = tslib_1.__importDefault(require("query-string"));
var getAllComments = function (model, id, markAllAsSeen) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        return [2 /*return*/, api_1.default
                .get("/api/note/".concat(model, "/").concat(id, "?markAllAsSeen=").concat(Boolean(markAllAsSeen)))
                .then(api_1.extractData)
                .catch(api_1.errorHandler)];
    });
}); };
exports.getAllComments = getAllComments;
var sendComment = function (model, id, comment, markCreatedAsSeen) {
    return api_1.default.post("/api/note/".concat(model, "/").concat(id), { comment: comment, markCreatedAsSeen: markCreatedAsSeen }).then(api_1.extractData).catch(api_1.errorHandler);
};
exports.sendComment = sendComment;
var deleteComment = function (model, id) {
    return api_1.default.delete("/api/note/".concat(model, "/").concat(id)).then(api_1.extractData).catch(api_1.errorHandler);
};
exports.deleteComment = deleteComment;
var autocompleteMentions = function (q) {
    return api_1.default
        .get("/api/note/mention-autocomplete?".concat(query_string_1.default.stringify({ q: q })))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
};
exports.autocompleteMentions = autocompleteMentions;
var pinComment = function (model, id, action) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        return [2 /*return*/, api_1.default
                .put("/api/note/".concat(model, "/").concat(id, "?").concat(query_string_1.default.stringify({ action: action })))
                .then(api_1.extractData)
                .catch(api_1.errorHandler)];
    });
}); };
exports.pinComment = pinComment;
